import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { LeverandoerOpkraevningService } from '../leverandoer-opkraevning.service';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-leverandoer-opkraevning-result',
  imports: [
    DatePipe,
    DecimalPipe,
    TableModule,
    TableRowDirective,
    KeepScrollPositionDirective,
  ],
  templateUrl: './leverandoer-opkraevning-result.component.html',
  styleUrl: './leverandoer-opkraevning-result.component.css',
})
export class LeverandoerOpkraevningResultComponent {
  leverandoerOpkraevningService = inject(LeverandoerOpkraevningService);
  data = this.leverandoerOpkraevningService.datasource.data;
  tableData = computed(() => this.data()?.data || []);

  onRowSelect(e: TableRowSelectEvent) {
    this.leverandoerOpkraevningService.selectLeverandoerOpkraevningResultRow(
      e.data
    );
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.leverandoerOpkraevningService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }

  async exportData(event: MouseEvent, leverandoerOpkraevningId: number) {
    event.stopPropagation();
    this.leverandoerOpkraevningService.exportData(leverandoerOpkraevningId);
  }
}
